import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
        <div style={{textAlign: "right", marginTop: 5}}>
            <span className={"cardHeader"}>{props.tech}</span>
        </div>
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
          {props.github &&
          <Button style={{fontWeight: "bold", marginLeft: 10, marginRight: 10, paddingLeft: 30, paddingRight: 30, color: '#FFF'}} variant="primary" href={props.github} target="_blank">
              Github
          </Button>
          }

        {"\n"}
        {"\n"}

          {props.demo &&
          <Button style={{fontWeight: "bold", marginLeft: 10, marginRight: 10, paddingLeft: 30, paddingRight: 30}} variant="primary" href={props.demo} target="_blank">
              Demo
          </Button>
          }
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
